import { render, staticRenderFns } from "./Section8.vue?vue&type=template&id=71ca7fc1&scoped=true"
import script from "./Section8.vue?vue&type=script&lang=js"
export * from "./Section8.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ca7fc1",
  null
  
)

export default component.exports